const micrositeCategoriesDefaultState = {
  data: {},
  loading: false,
  error: false,
  success: false,
  successMessage: '',
  errorMessage: null
};

const micrositeCategoriesReducer = (state = micrositeCategoriesDefaultState, action) => {
  switch(action.type) {
    case 'START_GET_MICROSITE_CATEGORIES':
      return {
        ...state,
        loading: true,
        error: false,
        errorMessage: null,
        successMessage: '',
      };
    case 'GET_MICROSITE_CATEGORIES_SUCCESS':
      return {
        ...state,
        data: action.micrositeCategories,
        loading: false,
        error: false,
        errorMessage: null,
      };
    case 'SHOW_ERROR':
      return {
        ...state,
        loading: false,
        error: true,
        successMessage: '',
        errorMessage: action.errorMessage
      };
    default:
      return state;
  }
};

export default micrositeCategoriesReducer;